import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./MainSidebar";
import Header from "./MainHeader";
import { useEffect, useState } from "react";
import ProductTourCard from "./ProductTourCard";
import SideContent from "./DashBoardContent";
import Campaigns from "./Campaigns";
import AccountSetup from "./AccountSetting/AccountSetup";
import { Routes, Route, useNavigate } from "react-router-dom";
import ClientRFPModal from "../../shared/createForms/ClientRFPModal";
import TeamMembers from "../ClientDashboard/TeamMember/TeamMembers";
import MainCampaign from "./CampaignDetails/MainCampaign";
import CampaignDashboard from "./CampaignDashboard";
import ClientCampaignsTable from "./ClientCampaignsTable";
import RecceApprovalCard from "./RecceApproval/RecceApprovalCard";
import Method from "./RecceApproval/Method";
import RecceApprovalTable from "./RecceApproval/RecceApprovalTable";
import axios from "axios";

const MainDashBoard = () => {
  const clientId = localStorage.getItem("clientId");
  const userRole = localStorage.getItem("userRole");

  const serverURL = process.env.REACT_APP_URL;

  const [isOpen, setIsOpen] = useState(false);
  // const [isClientOnBoarded, setIsClientOnboarded] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [adminsData, setAdminsData] = useState([]);
  const [logo, setLogo] = useState(null);
  const [isAllCampaignLoading, setIsAllCampaignLoading] = useState(false);
  const [isOrganizationId, setIsOrganizationId] = useState("");
  const [totalCampaign, setTotalCampaign] = useState(0);
  const [allCampaigns, setAllCampaigns] = useState([]);

  const getCampaignList = async (
    page,
    limit,
    organizationId,
    searchQuery = "",
  ) => {
    setIsAllCampaignLoading(true);
    const paramsObject = {
      organizationId: organizationId,
      getFromClient: true,
      searchQuery: searchQuery.trim(),
    };
    if (localStorage.getItem("userRole") == 2) {
      paramsObject.campaignOwnerId = localStorage.getItem("clientId");
    }

    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${serverURL}/campaign/allCampaigns?page=${page}&limit=${limit}`,
        // `${serverURL}/campaign/allCampaigns`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: paramsObject,
        },
      );
      if (response?.data?.success) {
        setTotalCampaign(response?.data?.totalCampaigns);
        setCampaigns(response?.data?.data);
        // setTotalPages(response?.data?.totalPages);
        setAdminsData(response?.data?.adminsData || []);
        setIsAllCampaignLoading(false);

        // oldData = response?.data?.data;
        // setCampaignListLoading(false);
      }
    } catch (error) {
      console.error("Error fetching campaign:", error);
      setIsAllCampaignLoading(false);
    }
  };

  let organizationId;

  const clientDetails = async (clientId) => {
    try {
      const userDetails = await axios.get(
        `${serverURL}/client/dashboard/${clientId}`,
      );
      if (userDetails.data.success) {
        organizationId = userDetails.data.data.organizationId;
        let page = 1;
        let limit = 100;

        // getCampaignList(page, limit, organizationId);
        setLogo(userDetails?.data?.organizationData?.organizationId?.brandLogo);
        setIsOrganizationId(organizationId);
      }
    } catch (error) {
      console.error("error in getting user details", error);
    }
  };
  useEffect(() => {
    if (localStorage.getItem("isClientOnBoarded") == "false") {
      setIsModalOpen(true);
    } else {
      setIsModalOpen(false);
    }

    clientDetails(clientId);
  }, []);

  useEffect(() => {
    const fetchAllCampaigns = async () => {
      if (!isOrganizationId) return;

      try {
        const token = localStorage.getItem("token");

        const res = await axios.get(
          `${process.env.REACT_APP_URL}/campaign/search-suggestions?organizationId=${isOrganizationId}&clientRequest=true`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );

        if (res.data.success) {
          setAllCampaigns(res.data.data); // 🔥 full dataset
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchAllCampaigns();
  }, [isOrganizationId]);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutsideSidebar = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };

  const handleLogoImg = (data) => {
    setLogo(data);
  };

  return (
    <div className="flex">
      <Sidebar
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        toggleSidebar={toggleSidebar}
        logo={logo} // pass the current logo
      />

      <div className="flex-grow max-w-full">
        <Header isOpen={isOpen} setIsOpen={setIsOpen} />

        <div
          className={` ${
            isOpen ? `ml-64` : `ml-16`
          } max-w-full px-4 py-2   overflow-auto  `}
          style={{
            height: "88vh",
            backgroundColor: "var(--dashboard-bg-color)",
          }}
        >
          <Routes>
            {userRole == 1 && (
              <Route
                path="dashboard"
                element={<SideContent ongoingCampaigns={campaigns} />}
              />
            )}

            {/* <Route path="RFP" element={<Campaigns />} /> */}
            <Route
              path="account"
              element={<AccountSetup onLogoImg={handleLogoImg} />}
            />
            {/* <Route
              path="createRFP"
              element={<ClientRFPModal selectedCampaign={null} />}
            /> */}
            <Route
              path="editRFP/:id"
              element={<ClientRFPModal selectedCampaign={selectedCampaign} />}
            />
            <Route path="Users" element={<TeamMembers />} />
            {/* <Route path="Campaign" element={<ClientCampaignsTable />} /> */}

            <Route
              path="AllCampaigns"
              element={
                <RecceApprovalCard
                  campaigns={campaigns}
                  isAllCampaignLoading={isAllCampaignLoading}
                  adminsData={adminsData}
                  getCampaignList={getCampaignList}
                  isOrganizationId={isOrganizationId}
                  totalCampaignCount={totalCampaign}
                  allCampaigns={allCampaigns}
                />
              }
            />
            <Route
              path="campaign/:id/reccejobApprove"
              element={<RecceApprovalTable />}
            />
            {/* <Route path="RecceApproval/:id" element={<Method />} /> */}
            {/* <Route path="RecceApproval/:id" element={<MainCampaign />} /> */}
            <Route path="campaign/:id" element={<CampaignDashboard />} />

            {/* <Route path="Campaign/:id" element={<MainCampaign />} /> */}
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default MainDashBoard;
